/**
 * Extracts an error message from an API error response.
 * Handles various error response structures from axios/API calls.
 *
 * @param error - The error object from a catch block
 * @returns The error message string if found, undefined otherwise
 */
export const extractErrorMessage = (error: unknown): string | undefined => {
  if (
    error &&
    typeof error === 'object' &&
    'response' in error
  ) {
    const apiError = error as { response?: { data?: { message?: string; detail?: string } } }
    return apiError.response?.data?.detail ?? apiError.response?.data?.message
  }
  return undefined
}

export const extractErrorCode = (error: unknown): number | undefined => {
  if (
    error &&
    typeof error === 'object' &&
    'response' in error
  ) {
    const apiError = error as { response?: { data?: { code?: number } } }
    return apiError.response?.data?.code
  }
  return undefined
}

